class PWRProduct {

    constructor(root) {

        this.root = root;

    }

    variantChanged(variant) {

        this.root.dispatchEvent(
            new CustomEvent("pwr:variant", {
                bubbles: true,
                detail: {
                    variant
                }
            })
        );

    }

}